import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=c086d580&scoped=true"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"
import style0 from "./FormData.vue?vue&type=style&index=0&id=c086d580&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c086d580",
  null
  
)

export default component.exports